import { addCalendarDays, todayBusinessDate } from '@shared/lib/businessDay'
import { businessDayUtcBounds } from '@shared/lib/customerEventDayBounds'
import { placeTimezone } from '../settingsStorage'

export const LIVE_ORDER_STATUSES = ['pending', 'submitted', 'processing'] as const

export function liveCacheTimezone(): string {
  return placeTimezone()
}

/** Today 00:00 in the place timezone (ISO). Live listeners use this as the floor. */
export function liveStartIso(nowIso = new Date().toISOString()): string {
  const tz = liveCacheTimezone()
  const today = todayBusinessDate(tz, nowIso)
  return businessDayUtcBounds(today, tz).startIso
}

export function liveWindowBusinessDates(nowIso = new Date().toISOString()): {
  today: string
  yesterday: string
} {
  const tz = liveCacheTimezone()
  const today = todayBusinessDate(tz, nowIso)
  return { today, yesterday: addCalendarDays(today, -1) }
}

/** True when a yyyy-MM-dd day is already covered by the live window (today only). */
export function isDateInLiveWindow(date: string, nowIso = new Date().toISOString()): boolean {
  const { today } = liveWindowBusinessDates(nowIso)
  return date === today
}

export function monthKeyBounds(monthKey: string): { startIso: string; endIso: string } {
  const tz = liveCacheTimezone()
  const start = `${monthKey}-01`
  const [y, m] = monthKey.split('-').map(Number)
  const nextMonth =
    m === 12 ? `${y + 1}-01-01` : `${y}-${String(m + 1).padStart(2, '0')}-01`
  return {
    startIso: businessDayUtcBounds(start, tz).startIso,
    endIso: businessDayUtcBounds(nextMonth, tz).startIso,
  }
}

export function businessDayIsoBounds(date: string): { startIso: string; endIso: string } {
  return businessDayUtcBounds(date, liveCacheTimezone())
}

export function nowMs(): number {
  return typeof performance !== 'undefined' && typeof performance.now === 'function'
    ? performance.now()
    : Date.now()
}
